import { Box, makeStyles, } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import timeManager from '../utils/TimeManager'


const useStyles = makeStyles((theme) => ({
  box: {
    background: 'rgba(0,0,0,0.3)',
  },
}));

function DiceRoll({ text }) {
  const classes = useStyles();
  return (
    <Box p={2} className={classes.box}>{text}</Box>
  )
}

export default function DiceHistory({ diceHistory }) {
  const classes = useStyles();
  return diceHistory
    .sort((a, b) => a.time.getTime() - b.time.getTime()) // ordena o historico pela data
    .reverse() // coloca ao contrario para aparecer de mais novo para antigo
    .map((dice, index) => (
      <Box pb={3} key={index}>
        <DiceRoll text={`${timeManager.formatTime(dice.time)} - ${dice.playerName} - ${dice.text}`} />
      </Box>
    ))
}
